// Package imports
import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import InputAdornment from "@mui/material/InputAdornment";
import "../Installation/InstallationLayout.css";
import { fetchSiteConfig } from "../../Store/Slices/DefsSlice";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import Confirmation from "../../Components/Modal/Confirmation";
import LoginHeader from "../../Components/UI/LoginHeader";
import LoginFooter from "../../Components/UI/LoginFooter";

// Custom imports
import { validator } from "../../Js/Validator";

const RecoverPassword = () => {
    // Hooks  
    const navigation = useNavigate();
    const dispatch = useDispatch();

    // Redux state
    const siteConfig = useSelector((state) => state.defs.siteConfig);

    // State
    const [username, setUsername] = useState("");
    const [validate, setValidate] = useState(false);
    const [usernameError, setUsernameError] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);

    // On blur get school name to display on top
    const getDefsFromAlias = () => {
        if (!username.includes("@")) {
            setUsernameError("Incorrect username!");
            setValidate(false);
            return false;
        }

        let alias = username.split("@");
        if (alias[alias.length - 1].trim().length == 0) {
            setUsernameError("Alias is missing!");
            setValidate(false);
            return false;
        }

        dispatch(
            fetchSiteConfig({
                keyid: "site_config",
                keydata: {
                    customer: {
                        licenceAlias: alias[alias.length - 1].toUpperCase().trim(),
                    },
                },
            })
        );
    };

    // Validate username on blur
    const usernameBlurValidate = () => {
        let validate = validator({ required: true, value: username });
        if (!validate["validate"]) {
            setUsernameError(validate["message"]);
            setValidate(false);
        } else {
            setUsernameError(null);
            setValidate(true);
            getDefsFromAlias();
        }
    };

    // Validate credentials on login click & redirect to respective dashboard
    const validateCredentials = async () => {
        usernameBlurValidate();
    };

    return (
        <Grid
            container
            spacing={1}
            className="full-height"
            sx={{ alignItems: "center" }}
        >
            <Grid item sm={12} md={6}>
                <Box
                    sx={{
                        bgcolor: "primary.main",
                        color: "primary.contrastText",
                        display: { xs: "none", sm: "none", md: "block" },
                    }}
                    className="full-height"
                >
                    <img
                        src={require('../../assets/login.webp')}
                        width="100%"
                        alt="Vocablab"
                    ></img>
                </Box>
            </Grid>
            <Grid item sm={12} md={6}>
                <Box sx={{ p: 1, textAlign: "center" }}>
                    <LoginHeader
                        primaryText={
                            !siteConfig || !siteConfig.schoolName
                                ? "Your Institute"
                                : siteConfig.schoolName
                        }
                        secondaryText="Enter Your User Name"
                    ></LoginHeader>
                    <Box>
                        {/* {validateErrorMessage != null && (
                                <Box sx={{ pt: 5, px: 10, textAlign: "center" }}>
                                    <Alert variant="filled" severity="error">
                                    {validateErrorMessage}
                                    </Alert>
                                </Box>
                                )} */}
                        <Box sx={{ pt: 5, px: 10, textAlign: "left" }}>
                            <TextField
                                id="username"
                                name="userpass"
                                tabIndex={0}
                                placeholder="Enter Username"
                                variant="outlined"
                                fullWidth
                                onBlur={() => {
                                    usernameBlurValidate();
                                }}
                                onInput={(event) => {
                                    setUsername(event.target.value);
                                }}
                                InputProps={{
                                    inputProps: { style: { padding: 10 } },
                                    style: { borderRadius: 30 },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AccountCircle sx={{
                                                color: "#D9D9D9", '@media (min-width: 1636px)': {
                                                    fontSize: '2rem'
                                                }
                                            }} />
                                        </InputAdornment>
                                    ),
                                    sx: {
                                        fontSize: '0.9rem', color: 'primary.main', fontWeight: '500', '@media (min-width: 1636px)': {
                                            fontSize: '1.4rem'
                                        }
                                    }
                                }}
                                value={username}
                                helperText={usernameError}
                                error={usernameError != null}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 13) {
                                        validateCredentials();
                                    }
                                }}

                            />                            
                        </Box>
                        <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={validateCredentials}
                                sx={{
                                    borderRadius: 20, fontWeight: "600", '@media (min-width: 1636px)': {
                                        fontSize: '1.2rem'
                                    }
                                }}
                            >
                                {" "}
                                Validate{" "}
                            </Button>
                        </Box>
                        <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
                            <Button
                                variant="outlined"
                                fullWidth
                                onClick={() => {
                                    navigation(-1);
                                }}
                                sx={{
                                    borderRadius: 20, fontWeight: "600", '@media (min-width: 1636px)': {
                                        fontSize: '1.2rem'
                                    }
                                }}
                            >
                                {" "}
                                Login{" "}
                            </Button>
                        </Box>
                        <LoginFooter></LoginFooter>
                    </Box>
                    <Confirmation
                        visible={modalVisible}
                        primaryText="Incorrect Passcode!"
                        image="error"
                        alert={true}
                        toggleModal={(flag) => setModalVisible(flag)}
                        timeout={5000}
                    ></Confirmation>
                </Box>
            </Grid>
        </Grid>
    );
}
export default RecoverPassword;